export default __webpack_public_path__ + "static/media/Bill_Chuan.a4d5908f.jpg";